/* Tab groups for the Capsaicina page (problem tabs, timeline tabs).
   Markup contract, per [data-av-tabs] container:
     button[data-av-tab="<key>"]  - the tab
     [data-av-panel="<key>"]      - the panel it shows
   Delegated from the document, so sections re-rendered by the theme editor
   keep working without re-binding. */
(function () {
  'use strict';

  function activate(group, key) {
    group.querySelectorAll('[data-av-tab]').forEach(function (b) {
      var on = b.getAttribute('data-av-tab') === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    group.querySelectorAll('[data-av-panel]').forEach(function (p) {
      var on = p.getAttribute('data-av-panel') === key;
      p.classList.toggle('is-active', on);
      p.hidden = !on;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-av-tab]');
    if (!btn) return;
    var group = btn.closest('[data-av-tabs]');
    if (!group) return;
    e.preventDefault();
    activate(group, btn.getAttribute('data-av-tab'));
  });

  // Left/right arrows move between tabs, as a tablist should.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var btn = e.target.closest && e.target.closest('[data-av-tab]');
    if (!btn) return;
    var group = btn.closest('[data-av-tabs]');
    if (!group) return;
    var tabs = [].slice.call(group.querySelectorAll('[data-av-tab]'));
    var i = tabs.indexOf(btn);
    var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    if (!next) return;
    e.preventDefault();
    activate(group, next.getAttribute('data-av-tab'));
    next.focus();
  });

  // Show the first tab of every group on load, in case none is marked active.
  function init() {
    document.querySelectorAll('[data-av-tabs]').forEach(function (group) {
      if (group.querySelector('[data-av-tab].is-active')) return;
      var first = group.querySelector('[data-av-tab]');
      if (first) activate(group, first.getAttribute('data-av-tab'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
